import React from 'react';
import {Upload, Icon} from 'antd';
import download from '../../util/fileDownload';

class Document extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            fileList: []
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.documents.length) {
            const {generateUrl} = nextProps;

            const fileList = nextProps.documents.map(({id: uid, file: {original_file_name: name, status = 'done'}}) => {
                return {
                    uid,
                    name,
                    status,
                    url: generateUrl(uid)
                }
            });
            return {fileList, loading: false};
        }
        return {fileList: [], loading: false};
    }
    handleChange(info) {
        this.setState({
            loading: info.file.status === 'uploading',
            fileList: [...info.fileList]
        });
    }
    render() {
        const {onUpload, onRemove} = this.props;
        const {fileList, setting} = this.state;

        const onPreview = (file) => {
            const {url, name} = file;
            return download(url, name);
        };

        return (
            <Upload
                className="insurance-document"
                name="document"
                data={{settings_id: setting}}
                customRequest={onUpload}
                onChange={this.handleChange.bind(this)}
                onPreview={onPreview}
                onRemove={onRemove}
                fileList={fileList}
            >
                {fileList.length ? null : (
                    <a>
                        <Icon type='upload'/> Upload Document
                    </a>
                )}
            </Upload>
        )
    }
};

export default Document;


// WEBPACK FOOTER //
// ./resources/assets/js/components/contractor/InlineDocument.js